export default {"src":"/_next/static/media/stash-logo.7267a09e.svg","height":66,"width":298,"blurWidth":0,"blurHeight":0};